import { Box, Button, colors, DialogContent, DialogTitle, Drawer, Grid, Grid2, Input, styled, SxProps, useTheme } from "@mui/material";
import { AppIconsReplaced } from "../../AppIcons";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const DrawerHeaderBox = styled(Box, { label: "DrawerPartDetails-Header" })(
    ({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        padding: 10,
        height: 55,
        display: "flex",
        color: theme.palette.primary.contrastText,
        alignItems: 'center',
        justifyContent: 'space-between',
    })
);
export const PartImage = styled("img", { label: "DrawerPartDetails-PartImage" })(
    ({ theme }) => ({
        maxWidth: 200,
        maxHeight: 200,
    })
);

export const DrawerWithoutBackground = styled(Drawer, { label: "DrawerPartDetails-DrawerWithoutBackground" })(
    ({ theme }) => ({
        width: "100%",
        maxWidth: 550,
        left: "auto",
        ">.MuiPaper-root": {
            width: '100%',
            position: 'relative',
            // height: "calc(100vh - 55px - 47px)",
            //  marginTop: 55,
        },
        "> .MuiModal-backdrop": {
            backgroundColor: "transparent !important",
        }
    })
);

export const BoxLeft = styled(Box, { label: "DrawerPartDetails-BoxLeft" })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        width: 'calc(100% - 100px)',
        "> img": {
            marginRight: 10,
        }
    })
);

export const BoxRight = styled(Box, { label: "DrawerPartDetails-Boxright" })(
    ({ theme }) => ({
        display: 'flex',
        "button": {
            marginRight: 10,

            "svg": { fontSize: 19, },
            "&:last-of-type": {
                marginRight: 0,
            }
        }
    })
);

export const BoxDescription = styled(Box, { label: "DrawerPartDetails-BoxDescription" })(
    ({ theme }) => ({
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    })
);

export const AppIconsReplacedCustom = styled(AppIconsReplaced, { label: "DrawerPartDetails-AppIconsReplacedCustom" })(
    ({ theme }) => ({
        fontSize: 28,
        //position: 'absolute',
        // marginTop: 4,
    })
);

export const BoxImagePreview = styled(Box, { label: "DrawerPartDetails-BoxImagePreview" })(
    ({ theme }) => ({
        width: 250,
        height: 250,
        border: '1px solid ' + StyleguideSavioColors.lighterGrey,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    })
);

export const PartDetailsCode = styled("span", { label: "DrawerPartDetails-PartDetailsCode" })(
    ({ theme }) => ({
        // paddingLeft: 35,
        // marginTop: -4,
    })
);

export const SectionItems = styled(Box, { label: "DrawerPartDetails-SectionItems" })(
    ({ theme }) => ({
        width: "100%",
        height: "calc(100% - 295px)",

    })
);

export const BoxText = styled(Box, { label: "DrawerPartDetails-BoxText" })(
    ({ theme }) => ({
        "> *": {
            fontSize: 14,
            lineHeight: '19px',
        },
        ">p": {
            color: StyleguideSavioColors.text.black,
        },
        "h3": {
            color: StyleguideSavioColors.blue,
        }
    })
);

export const BoxIcon = styled(Box, { label: "DrawerPartDetails-BoxIcon" })(
    ({ theme }) => ({
        color: theme.palette.primary.main,
        "svg": { fontSize: 30, }
    })
);

export const ContainerInfoPreview = styled(Box, { label: "DrawerPartDetails-ContainerInfoPreview" })(
    ({ theme }) => ({
        justifyContent: 'flex-end',
        paddingLeft: 10,
    })
);

export const Unity = styled(Box, { label: "DrawerPartDetails-Unity" })(
    ({ theme }) => ({
        fontSize: 14,
        display: 'flex',
        marginTop: 10,
        justifyContent: 'flex-end',


        ">p": {
            "&:first-of-type": {
                textTransform: 'uppercase',
                color: theme.palette.primary.main,
            },
            "&:last-of-type": {
                color: StyleguideSavioColors.text.black,
            }
        }
    })
);

export const ContainerInputNumber = styled(Box, { label: "DrawerPartDetails-ContainerInputNumber" })(
    ({ theme }) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 20,
        alignItems: 'center',
        "input[type='number']": {
            border: '1px solid ' + StyleguideSavioColors.lightGrey,
            height: 33,
            boxSizing: 'border-box',
            borderLeft: 0,
            borderRight: 0,
            textAlign: 'center',
            fontSize: 14,








        },

        ".MuiInput-root": {
            boxShadow: 0,

            "&:before, &:after": {
                display: 'none',
            }
        }
    })
);

export const ContainerTextCart = styled(Box, { label: "DrawerPartDetails-ContainerTextCart" })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        justifyContent: 'flex-end',
        ">span": {
            "&:nth-of-type(1)": {
                color: StyleguideSavioColors.text.black,
            },
            "&:nth-of-type(2)": {
                color: StyleguideSavioColors.mainBlue,
                marginLeft: 5,
                marginRight: 5,
            }
        }
    })
);

export const BoxStatus = styled(Box, { label: "DrawerPartDetails-BoxStatus" })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: theme.palette.primary.main,
        fontSize: 14,
        paddingRight: 3,
        "svg": {
            fill: theme.palette.primary.main,
            marginLeft: 5,
        }
    })
);

export const RowGrid2 = styled(Button, { label: "DrawerPartDetails-RowGrid2" })(
    ({ theme }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: "left",
        width: '100%',
        height: "100%",
        padding: '10px 20px',
        borderBottom: '1px solid ' + StyleguideSavioColors.lighterGrey,
    })
);


export const RowTable = styled(Grid2, { label: "DrawerPartDetails-RowTable" })(
    ({ theme }) => ({
        display: 'flex',
        marginBottom: 7,

    })
);

export const ColumnTable = styled(Grid2, { label: "DrawerPartDetails-ColumnTable" })(
    ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 20px',
        borderBottom: '1px solid ' + StyleguideSavioColors.lighterGrey,
    })
);

export const TitleField = styled(Grid2, { label: "DrawerPartDetails-TitleField" })(
    ({ theme }) => ({
        width: 130,
        minWidth: 130,
        backgroundColor: StyleguideSavioColors.footerGrey,
        fontSize: 14,
        textAlign: 'right',
        height: '100%',
        color: StyleguideSavioColors.text.black,
        padding: 3,
    })
);

export const ValueField = styled(Grid2, { label: "DrawerPartDetails-ValueField" })(
    ({ theme }) => ({
        fontSize: 14,
        padding: 3,
        color: StyleguideSavioColors.text.black,
    })
);

export const BoxTabs = styled(Box, { label: "DrawerPartDetails-BoxTabs" })(
    ({ theme }) => ({
        borderTop: '1px solid ' + StyleguideSavioColors.lightGrey,
        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
        ".MuiTabs-root": {
            minHeight: 45,
        },
        "button": {
            overflow: 'visible',
            minHeight: 45,
            paddingLeft: 30,
            paddingRight: 30,
            textTransform: "uppercase",
            color: StyleguideSavioColors.text.black,
            "&:last-of-type": {
                position: 'relative',
                "::after": {
                    content: "'/'",
                    position: "absolute",
                    fontSize: 37,
                    left: -6,
                    top: 0,
                    color: StyleguideSavioColors.lightGrey,
                    fontWeight: StyleguideSavioFonts.normal
                },
            },
            "&.Mui-selected": {
                fontWeight: StyleguideSavioFonts.bold,
            }
        },
        ".MuiTabs-indicator": {
            display: 'none',
        },
        "~ div": {
            height: "calc(100% - 50px)",
            overflow: 'hidden',
            overflowY: 'auto',
        }
    })
);

export const InputQuantity = styled(Input, { label: "DrawerPartDetails-InputQuantity" })(
    ({ theme }) => ({
        // Per nascondere le frecce su Webkit (Chrome, Safari, Edge)
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0,
        },
        // Per nascondere le frecce su Firefox
        "& input[type=number]": {
            MozAppearance: "textfield",
        },
    }))


//------popup

export const DialogTitleStyled = styled(DialogTitle, { label: "DrawerPartDetails-DialogTitleStyled" })(
    ({ theme }) => ({

        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: "space-between",
        textTransform: 'uppercase',
        padding: '8px 6px 8px 14px',
        ">div": {
            display: 'flex',
            alignItems: 'center',

        },
        "button": {
            marginLeft: 10,
            padding:4,
            marginTop: -3,

            "svg": { fontSize: 18, }
        },
        ">svg": { marginRight: 5, }

    }))


export const DialogContentStyled = styled(DialogContent, { label: "DrawerPartDetails-DialogContenteStyled" })(
    ({ theme }) => ({
        fontSize: 14,
        padding: 0,
        maxHeight: 400,

        ">ul": {
            padding: 0,
        },

        "ul li": {
            fontSize: 14,
            paddingTop: 2,
            paddingBottom: 2,
            color: StyleguideSavioColors.text.black + " !important",
        },
        ".MuiMenuItem-root:hover": {
            backgroundColor: "#fff !important",
            textDecoration: 'underline',
            color: StyleguideSavioColors.blue + " !important",
            "&:before": {
                display: 'block',
                content: "''",
                width: 3,
                height: '100%',
                backgroundColor: StyleguideSavioColors.blue,
                left: 0,
                position: 'absolute',
                zIndex: 1,

            },
        }
    }))


export const SwitchContainer = styled(Box, { label: "DrawerPartDetails-SwitchContainer" })(
    ({ theme }) => ({
        ".MuiFormControlLabel-label": {
            fontSize: 14,
            paddingTop: 2,
        }

    })
);
